var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 49,
    viewBox: "0 0 64 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9667 0H40.1667V9.8H49.9667V0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8333 0H14.0333V49H23.8333V0Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9 13.0667V49H27.1V22.8667L36.9 13.0667Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7667 13.0667V49H0.966675V22.8667L10.7667 13.0667Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0333 0H53.2333V9.8H63.0333V0Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9667 13.0667H40.1667V27.7667V35.9333H53.2333V39.2H40.1667V49H53.2333H54.8667H63.0333V35.9333V34.3V21.2333V13.0667H49.9667ZM53.2333 27.7667H49.9667V21.2333H53.2333V27.7667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo_black.e74891bf8af8970375a61c4d6126a6b3.svg";
export { ForwardRef as ReactComponent };